import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Modal from "react-bootstrap/Modal";

import CharacterLimitIndicator from "../reusable/character_limit_indicator";
import { ProductContext } from "../data/product_context_management";
import useProductUpdateApi from "../data/use_product_update_api";
import SaveSpinnerButton from "./save_spinner_button";
import { descriptionMaxLength, productDescriptionYupSchema } from "../../../yup_schemas/product_schema";

function DescriptionForm() {
  const context = useContext(ProductContext);

  const { product, isUpdating, setOpenEditModal, setGeneralError } = context;

  const [descriptionLength, setDescriptionLength] = useState(product.description?.length || 0);
  const { updateProduct } = useProductUpdateApi({ ...context });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(productDescriptionYupSchema),
  });

  const handleDescriptionChange = (event) => {
    setDescriptionLength(event.target.value.length);
  };

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const onSubmit = async (data, event) => {
    /* eslint-disable camelcase */
    event.preventDefault();

    const { display_style_preference } = data;

    const pageConfig = {
      ...product.page_config,
      display_style_preference,
    };

    const submitData = { ...data, page_config: pageConfig };

    updateProduct(submitData);
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3 row">
            <label htmlFor="overview" className="col-sm-3 col-form-label d-none">
              Description
            </label>
            <div className="">
              <textarea
                id="description"
                className="form-control"
                rows="6"
                {...register("description")}
                defaultValue={product.description}
                onChange={handleDescriptionChange}
              />
              <div className="mt-2">
                <CharacterLimitIndicator
                  fieldName="description"
                  length={descriptionLength}
                  maxLength={descriptionMaxLength}
                />
                {errors?.description && <span className="text-danger">{errors?.description?.message}</span>}
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <SaveSpinnerButton
          inactiveText="Save"
          activeText="Saving..."
          isSaving={isUpdating}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
        <button type="button" className="btn btn-link" onClick={closeModal}>
          Cancel
        </button>
      </Modal.Footer>
    </>
  );
}

export default DescriptionForm;
